module.exports = __webpack_public_path__ + "2512f82d8ad9ca1cb7c49fb2e3f2e7d5.pdf";